import { render, staticRenderFns } from "./DocumentoEdit.vue?vue&type=template&id=111effeb"
import script from "./DocumentoEdit.vue?vue&type=script&lang=js"
export * from "./DocumentoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports